import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import Icon from '@wtag/rcl-icon';
import { EmphasisTag } from '@wtag/react-comp-lib';
import getTripLabel, { SEARCH_RESULT } from '../../SearchDetails/flight/helpers/getTripLabel';

const PillTabsList = ({ tripCount, trip, isSelected, isChanged, canExchange }) => {
  const { origin, destination } = trip;

  return (
    <div className="pill-tabs__title">
      <span>{getTripLabel(tripCount, origin, destination, SEARCH_RESULT)}</span>
      {canExchange && isSelected && (
        <EmphasisTag
          size="tiny"
          type={isChanged ? 'danger' : 'disabled'}
          text={
            isChanged
              ? I18n.t('components.ibe.results.exchange_tag.changed')
              : I18n.t('components.ibe.results.exchange_tag.unchanged')
          }
        />
      )}
      <span
        className={classnames('icon-holder', {
          'icon-holder--selected': isSelected,
        })}
      >
        {isSelected && <Icon name="check" size="tiny" />}
      </span>
    </div>
  );
};

PillTabsList.defaultProps = {
  tripCount: null,
};
PillTabsList.propTypes = {
  tripCount: PropTypes.number,
  trip: PropTypes.shape({
    origin: PropTypes.string.isRequired,
    destination: PropTypes.string.isRequired,
  }).isRequired,
  isSelected: PropTypes.bool.isRequired,
  isChanged: PropTypes.bool.isRequired,
  canExchange: PropTypes.bool.isRequired,
};

export default PillTabsList;
